import { useEffect } from 'react';
import { Grid } from '@mui/material';

import { useApi } from '../../shared/hooks/use-api.hook';
import { JobUrls } from '../../shared/utils/api.utils';

import PageLayout from '../../components/shared/page-layout/page-layout.component';
import JobDetails from '../../components/job-details/job-details.component';

const Jobs = () => {
  const [getJobs, loadState, jobs] = useApi({ url: JobUrls.getJobs });

  useEffect(() => getJobs(), [getJobs]);

  return (
    <PageLayout heading='Job Openings'>
      <Grid
        container
        sx={{ width: '100%', paddingBottom: '70px' }}
        columns={1}
        rowGap='70px'
      >
        {jobs && jobs.map((job) => <JobDetails key={job.id} job={job} />)}
      </Grid>
    </PageLayout>
  );
};

export default Jobs;
